function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "95qgh09uba",
  d: "M0 0h16v16H0z"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "2q9r3svr8b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#95qgh09uba"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1.429 6.857h6V16H2.857a1.715 1.715 0 0 1-1.714-1.714V6.857c.095.009.19.009.286 0zm13.142 0c.095.009.191.009.286 0v7.429A1.715 1.715 0 0 1 13.143 16H8.57V6.857h6zM4 2.286a1.143 1.143 0 0 1 1.143-1.143 2.285 2.285 0 0 1 2.286 2.286H5.143A1.143 1.143 0 0 1 4 2.286zm6.857-1.143a1.143 1.143 0 0 1 0 2.286H8.571a2.285 2.285 0 0 1 2.286-2.286zm3.714 2.286h-1.748c.208-.346.318-.74.32-1.143A2.285 2.285 0 0 0 10.857 0C9.707 0 8.634.578 8 1.537A3.429 3.429 0 0 0 5.143 0a2.285 2.285 0 0 0-2.286 2.286c.002.403.112.797.32 1.143H1.43a1.429 1.429 0 0 0 0 2.857H14.57a1.429 1.429 0 0 0 0-2.857z",
  fill: "#0C131A",
  mask: "url(#2q9r3svr8b)"
}));

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _ref, _ref2);

export default __webpack_public_path__ + "static/media/gift-icon.beaa0779.svg";
export { SvgComponent as ReactComponent };